import { useAbility } from '@casl/react'
import PropTypes from 'prop-types'

import './styles.scss'
import { AbilityContext } from '../../../ability/context'
import { Permission, Action } from '../../../ability/types'
import SideNav from '../../shared/SideNav'

const adminRoles = [ 'medical_director', 'executive_director', 'administrator' ]

function LeftNav (props) {
  const { patientId, encounterType, clientName, roles, permissions } = props
  const rootUrl = `/patient/${clientName}/${patientId}/assessment`
  const r = roles[`${clientName}-compassion`]
  const isAdmS = r === 'administrative_support'
  const isAdmin = adminRoles.includes(r)
  const ability = useAbility(AbilityContext)
  const administrativeSupportStructure = [
    [
      [ 'Demographics' ],
      [ 'Patient', '/standarddemographicspatient' ],
      [ 'Insurance', '/standarddemographicsinsurance' ]
    ],
    [[ 'Encounter Summary', '/encountersummary' ]]
  ]
  // 1. Every item of this array will be separate list
  // 2. First item of list should be array also. Array can have 1 or 2 items. It will be a ListHeader
  // 2.1 First item of ListHeader array - text, second is the url, where header leads to
  // 3. Rest items of list adefaultStructurere ListItems. List item array can have 1 or 2 items length and behaves like ListHeader.
  const defaultStructure = [
    [[ 'Care Plan', '/igao' ]],
    ability.can(Action.READ, Permission.CLAIM_HISTORY) && [[ 'Claims History', '/claims-history' ]],
    [[ 'CSR', '/standardcsr' ]],
    [
      [ 'Demographics' ],
      [ 'Patient', '/standarddemographicspatient' ],
      [ 'Insurance', '/standarddemographicsinsurance' ],
      ability.can(Action.READ, Permission.ASSESSMENTS) && [ 'Home Assessment', '/standarddemographicshomeassessment' ],
      [ 'Family | Support', '/standarddemographicssupport' ]
    ].filter(Boolean),
    [[ 'Provider Network', '/standarddemographicsmedical' ]],
    [[ 'Narus Team', '/standarddemographicsnarusteam' ]],
    ability.can(Action.READ, Permission.MEDICAL_HISTORY) && [
      [ 'Medical History' ],
      [ 'Diagnosis', '/standardmedicaldiagnosis' ],
      [ 'Events', '/standardmedicalevents' ]
    ],
    ability.can(Action.READ, Permission.ASSESSMENTS) && [[ 'Assessments' ],
      [ 'Vitals', '/standardvitals' ],
      [ 'ESAS +', '/standardsymptomsesas' ],
      [ 'read', 'write' ].includes(permissions?.behavioral) &&
      [ 'Behavioral Health', '/standardbehavioral' ],
      [ 'Review of Systems', '/standardsymptomsros' ],
      [ 'Maternity', '/standardmaternity' ],
      [ 'Tribal', '/standardsocialhistorytribal' ]
    ].filter(Boolean),
    ability.can(Action.READ, Permission.ALLERGIES) && [[ 'Allergies', '/standardallergies' ]],
    ability.can(Action.READ, Permission.MEDICATIONS) && [[ 'Medications', '/standardmedications' ]],
    ability.can(Action.READ, Permission.SOCIAL_HISTORY) && [
      [ 'Social History' ],
      [ 'Lifestyle', '/standardsocialhistorylifestyle' ],
      [ 'Resources', '/standardsocialhistoryresources' ],
      [ 'Substance Use', '/standardsocialhistorysubstance' ]
    ],
    [
      [ 'Documents' ],
      ability.can(Action.READ, Permission.DIAGNOSTICS_DOCUMENTS) && [ 'Diagnostics', '/standarddiagnostics' ],
      [ 'General', '/standarddocuments' ]
    ].filter(Boolean),
    ability.can(Action.READ, Permission.GOALS) && [[ 'Goals', '/standardgoals' ]],
    ability.can(Action.READ, Permission.UTILIZATION) && [[ 'Utilization & Expense', '/utilizationexpense' ]],
    encounterType === 'grandRounds'
      ? [[ 'Grand Rounds', '/grandrounds' ]]
      : [[ 'Encounter Summary', '/encountersummary' ]],
    [[ 'Encounter History', '/encounterhistory' ]],
    (isAdmin || [ 'read', 'write' ].includes(permissions.uba_care)) && [[ 'UBACARE Orders', '/uba' ]]
  ].filter(Boolean)

  return (
    <SideNav
      {...props}
      basepath={rootUrl}
      structure={isAdmS ? administrativeSupportStructure : defaultStructure}
    />
  )
}

LeftNav.defaultProps = {
  patientId: 'test'
}

LeftNav.propTypes = {
  active: PropTypes.string,
  toggle: PropTypes.func,
  structure: PropTypes.instanceOf(Array),
  roles: PropTypes.instanceOf(Array),
  basepath: PropTypes.string,
  patientId: PropTypes.string,
  encounterType: PropTypes.string,
  clientName: PropTypes.string,
  visible: PropTypes.bool
}

export default LeftNav
